 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		49: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + ({"47":"common","48":"main"}[chunkId]||chunkId) + "." + {"0":"ad2fb717e549395bba25","1":"f54e7b318a284508649c","2":"6f2b7ef49dc371681e65","3":"5edb053569813e2b28af","4":"e78d1852f368c263a722","5":"8b64bebfc25969e0cf36","6":"5ec30b75c4096a860a62","7":"19b51a705ab8f49818b0","8":"15b695b514d9dd9c5b38","9":"c948cde63466a683a0bc","10":"fb4ca32c4b7610b0178f","11":"aea77bf407dc593c9789","12":"b465f78a6580849e14d7","13":"22333ca4f9a40189ad8f","14":"7a8c81367d50f193acd6","15":"5f8f63135ce87463e26c","16":"c3850277c62d98655a04","17":"def594b8c457233da40f","18":"6bf60c9ac7b9938ddb78","19":"a90538bbef5545af2071","20":"ea28725e66712adcbe2e","21":"0787ca87794b42888184","22":"e638f1995ca0d5e9d468","23":"e3b07636777f59154753","24":"76dd374415fd6de68e0d","25":"15611661fa880275310d","26":"f48f66047e18848407d7","27":"cb2af521749a4d5efeed","28":"b43e1bafa8ef47a402e3","29":"daff31beb545aff70c59","30":"ca33aef7297c5f78ea73","31":"3e2deac66bf3737d8abf","32":"05ecdf9733785f1a966e","33":"5eacaa5e77367f23af78","34":"f01edd7df79bd40561c0","35":"077c6830b833af02af27","36":"4242198202d65395de80","37":"c08f4c35b52da579cee5","38":"7d50eab08e947ac7a271","39":"d238abcffcf176fcf4b0","40":"3582b1f2e15c05520bc9","41":"3ea1f6ed10613971ad3a","42":"3e690d598198476250f3","43":"7a8e6bc5635353af86f0","44":"1ea0353c7e7d1a38505b","45":"5fc38495b89ea718ec6a","46":"cfb086c6c01314c9fb22","47":"8e02f57d96048ea78262","48":"645eff1fdf67c088c387"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/sites/ktu/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap a97c14b51c0b053ecaa3